import { render } from "./Livescorings.vue?vue&type=template&id=19c1f336&scoped=true"
import script from "./Livescorings.vue?vue&type=script&lang=js"
export * from "./Livescorings.vue?vue&type=script&lang=js"

import "./Livescorings.vue?vue&type=style&index=0&id=19c1f336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c1f336"]])

export default __exports__